import React, { Component } from 'react'
import './PolicyPage.scss'
import PrivacyTerms from '../../Components/Policy/PrivacyTerms'
import ServiceTerms from '../../Components/Policy/ServiceTerms'
import { withCookies, Cookies } from 'react-cookie'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import HeaderProject from '../../Components/Commons/HeaderProject'

class PolicyPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            position: '이용약관',
        }
    }

    changePosition = (posi) => {
        this.setState({ position: posi })
    }

    render() {
        return (
            <div>
                {this.props.cookies.get('project') ? <HeaderMenu /> : <HeaderProject />}
                <div className="section_wrap">
                    <div
                        className={
                            this.props.cookies.get('project')
                                ? 'policy_page_wrap common_wrap'
                                : 'policy_page_wrap common_wrap policy_page_wrap_n'
                        }>
                        <ul className="list_btn_wrap">
                            <li
                                onClick={() => {
                                    this.changePosition('이용약관')
                                }}
                                className={this.state.position === '이용약관' && 'active'}>
                                이용약관
                            </li>
                            <li
                                onClick={() => {
                                    this.changePosition('개인정보처리방침')
                                }}
                                className={this.state.position === '개인정보처리방침' && 'active'}>
                                개인정보처리방침
                            </li>
                        </ul>
                        {this.state.position === '이용약관' ? (
                            <div className="policy_wrap">
                                <ServiceTerms />
                            </div>
                        ) : (
                            <div className="policy_wrap">
                                <PrivacyTerms />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(PolicyPage)



// WEBPACK FOOTER //
// ./Src/Containers/Policy/PolicyPage.js